import { render, staticRenderFns } from "./dialog_goodsRecord.vue?vue&type=template&id=623bae5c&scoped=true&"
import script from "./dialog_goodsRecord.vue?vue&type=script&lang=js&"
export * from "./dialog_goodsRecord.vue?vue&type=script&lang=js&"
import style0 from "./dialog_goodsRecord.vue?vue&type=style&index=0&id=623bae5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623bae5c",
  null
  
)

export default component.exports